import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Spinner6 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 16 16"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2a2 2 0 113.999-.001A2 2 0 016 2zm6.359 6a1.641 1.641 0 013.282 0 1.641 1.641 0 01-3.282 0zm-1.602 4.243a1.486 1.486 0 112.971 0 1.486 1.486 0 01-2.971 0zM6.654 14a1.346 1.346 0 112.693.001A1.346 1.346 0 016.654 14zm-4.116-1.757a1.22 1.22 0 112.439 0 1.22 1.22 0 01-2.439 0zM.896 8a1.104 1.104 0 112.207 0A1.104 1.104 0 01.896 8zm1.861-4.243a1 1 0 012 0 1 1 0 01-2 0zm11.297 0a1.811 1.811 0 11-3.623 0 1.811 1.811 0 013.623 0z"
  }));
});
Spinner6.displayName = 'Spinner6';
export var Spinner6Dimensions = {
  height: 16,
  width: 16
};